import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import { Helmet } from "react-helmet";

function PostDetail() {
  const { id } = useParams();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);

  const posts = [
    {
      id: 1,
      title: 'Le Meraviglie della Letteratura Classica Italiana',
      image: '/images/1.jpg',
      date: '15 Gennaio 2025',
      author: 'Sofia Martini',
      fullContent: `La letteratura classica italiana rappresenta uno dei pilastri fondamentali della cultura occidentale. Autori come Dante Alighieri, Francesco Petrarca e Giovanni Boccaccio hanno contribuito in modo determinante alla formazione della lingua e della letteratura italiana.

      Dante Alighieri con la sua Divina Commedia ha creato un universo poetico senza precedenti, un viaggio attraverso Inferno, Purgatorio e Paradiso che esplora i temi della giustizia divina, del peccato e della redenzione. La sua opera ha influenzato generazioni di scrittori e poeti in tutto il mondo.

      Francesco Petrarca, padre dell umanesimo, ha rivoluzionato la poesia lirica con il suo Canzoniere, una raccolta di sonetti e canzoni dedicati all amore per Laura. La sua poetica ha dato vita al petrarchismo, movimento che si e diffuso in tutta Europa.

      Giovanni Boccaccio con il Decameron ha offerto uno spaccato della societa medievale attraverso cento novelle narrate da dieci giovani rifugiati durante la peste nera. La sua prosa elegante e vivace ha stabilito nuovi standard per la narrativa italiana.

      Questi autori non hanno solo creato opere letterarie immortali, ma hanno anche contribuito alla standardizzazione della lingua italiana, rendendola uno strumento espressivo raffinato e universale. Le loro opere continuano a essere studiate, tradotte e ammirate in tutto il mondo, testimoniando la grandezza eterna della letteratura italiana.

      Leggere i classici italiani significa immergersi in un patrimonio culturale ricchissimo, che offre spunti di riflessione sulla condizione umana, sulla bellezza del linguaggio e sulla profondita del pensiero. Ogni pagina e un viaggio nel tempo che arricchisce lo spirito e la mente.`
    },
    {
      id: 2,
      title: 'Cancelleria di Lusso: Arte e Funzionalita',
      image: '/images/2.jpg',
      date: '12 Gennaio 2025',
      author: 'Marco Bianchi',
      fullContent: `La cancelleria di lusso rappresenta molto piu di semplici strumenti per scrivere: e un mondo dove arte, artigianato e funzionalita si fondono per creare oggetti di straordinaria bellezza ed efficienza. In un era dominata dal digitale, la cancelleria di qualita celebra il valore della scrittura a mano e del tocco personale.

      Le penne stilografiche di prestigio sono vere e proprie opere d arte. Marchi storici come Montblanc, Parker e Waterman creano strumenti che combinano design elegante, materiali pregiati e meccanica di precisione. Ogni penna e un capolavoro di ingegneria, con pennini realizzati in oro o acciaio inossidabile che garantiscono una scrittura fluida e piacevole.

      I quaderni e i taccuini di alta qualita utilizzano carte pregiate, spesso prodotte con metodi tradizionali. La carta di cotone, la carta vergata o quella martellata offrono texture uniche che rendono la scrittura un esperienza sensoriale completa. Marchi come Moleskine, Leuchtturm1917 e Rhodia sono sinonimo di eccellenza nel settore.

      La cancelleria di lusso non e solo funzionale ma anche espressiva. Scegliere un determinato tipo di penna o quaderno riflette la personalita, lo stile e i valori di chi scrive. E un modo per distinguersi, per dare importanza ai propri pensieri e alle proprie parole.

      Inoltre, la cancelleria di qualita e un investimento duraturo. A differenza dei prodotti usa e getta, una buona penna stilografica puo durare una vita, diventando un oggetto da tramandare alle generazioni future. E uno strumento che cresce con noi, che porta i segni del tempo e della nostra storia personale.

      In conclusione, investire in cancelleria di lusso significa valorizzare la scrittura come forma d arte, riscoprire il piacere del gesto manuale e circondarsi di oggetti belli e significativi che arricchiscono la nostra quotidianita.`
    },
    {
      id: 3,
      title: 'Romanzi Contemporanei Italiani da Non Perdere',
      image: '/images/3.jpg',
      date: '10 Gennaio 2025',
      author: 'Elena Rossi',
      fullContent: `La letteratura italiana contemporanea sta vivendo un periodo di grande fermento e creativita. Numerosi autori italiani stanno conquistando il pubblico nazionale e internazionale con opere originali, profonde e coinvolgenti che esplorano temi universali attraverso prospettive innovative.

      Elena Ferrante ha rivoluzionato il panorama letterario con la sua Tetralogia Napoletana, una saga che racconta l amicizia tra due donne sullo sfondo della Napoli del secondo dopoguerra. La sua scrittura intensa e viscerale ha conquistato milioni di lettori in tutto il mondo, portando la narrativa italiana contemporanea alla ribalta internazionale.

      Paolo Giordano, fisico e scrittore, ha esordito con La solitudine dei numeri primi, un romanzo che esplora le fragilita umane e i traumi dell infanzia attraverso una prosa matematicamente precisa ed emotivamente potente. Le sue opere successive hanno confermato il suo talento nel fondere scienza e letteratura.

      Roberto Saviano con Gomorra ha aperto gli occhi del mondo sulla criminalita organizzata italiana, creando un opera di denuncia che e anche un capolavoro letterario. Il suo coraggio e la sua capacita narrativa hanno fatto di lui una voce fondamentale nel dibattito pubblico italiano.

      Nicola Lagioia, direttore del Salone del Libro di Torino, ha vinto il Premio Strega con La ferocia, un romanzo noir ambientato a Bari che esplora le dinamiche familiari e sociali con una prosa tagliente e incisiva.

      Questi autori, insieme a molti altri come Alessandro Baricco, Melania Mazzucco e Emanuele Trevi, stanno dimostrando che la letteratura italiana e viva, vitale e capace di dialogare con il mondo contemporaneo mantenendo la profondita e l eleganza che da sempre la caratterizzano.

      Leggere la letteratura italiana contemporanea significa comprendere il nostro tempo, le sue contraddizioni, le sue speranze e le sue paure attraverso la lente di autori che sanno trasformare la realta in arte.`
    },
    {
      id: 4,
      title: 'L Arte del Bookbinding: Rilegatura Artigianale',
      image: '/images/4.jpg',
      date: '8 Gennaio 2025',
      author: 'Giuseppe Ferrara',
      fullContent: `Il bookbinding, o rilegatura artigianale, e un arte millenaria che trasforma semplici fogli di carta in volumi preziosi, oggetti di bellezza e durata. In un epoca di produzione di massa, la rilegatura artigianale rappresenta un ritorno alla qualita, all attenzione ai dettagli e al valore dell oggetto libro come opera d arte.

      La storia della rilegatura risale all antichita, quando i monaci amanuensi creavano codici miniati rilegati con pelli pregiate e decorazioni elaborate. Ogni libro era un unicum, realizzato con pazienza e dedizione assoluta. Questa tradizione si e evoluta nel tempo, attraversando il Rinascimento e l era moderna, mantenendo viva la fiamma dell artigianato di qualita.

      Le tecniche di rilegatura sono molteplici: dalla rilegatura bradel, elegante e robusta, alla rilegatura giapponese, minimalista e raffinata, fino alla rilegatura copta, antica e affascinante. Ogni tecnica richiede abilita specifiche, strumenti dedicati e una profonda comprensione dei materiali.

      I materiali utilizzati nella rilegatura artigianale sono selezionati con cura: pelli naturali come il vitello, il marocchino e il capretto; carte pregiate; fili di lino; colle naturali. Ogni materiale contribuisce alla bellezza e alla durata del volume finito.

      La rilegatura artigianale non e solo una questione estetica, ma anche funzionale. Un libro ben rilegato puo durare secoli, resistendo all usura del tempo e preservando il suo contenuto per le generazioni future. E un investimento nella cultura e nella memoria.

      Oggi, nonostante la digitalizzazione, la rilegatura artigianale sta vivendo una rinascita. Sempre piu persone apprezzano il valore degli oggetti fatti a mano, della qualita artigianale e della bellezza che solo il lavoro umano puo creare. Biblioteche, collezionisti e amanti dei libri cercano rilegatori esperti per restaurare volumi antichi o creare nuove opere uniche.

      Imparare l arte della rilegatura e un viaggio affascinante che unisce manualita, creativita e rispetto per la tradizione, offrendo la soddisfazione di creare con le proprie mani oggetti di bellezza duratura.`
    },
    {
      id: 5,
      title: 'Biblioteche Storiche Italiane: Tesori di Conoscenza',
      image: '/images/5.jpg',
      date: '5 Gennaio 2025',
      author: 'Francesca Lombardi',
      fullContent: `Le biblioteche storiche italiane sono veri e propri scrigni di conoscenza, luoghi dove il tempo sembra essersi fermato e dove secoli di sapere sono custoditi gelosamente. Visitare queste biblioteche significa fare un viaggio nella storia, nella cultura e nell arte italiana.

      La Biblioteca Apostolica Vaticana e una delle piu antiche e importanti biblioteche del mondo. Fondata nel 1475, custodisce oltre 1,6 milioni di libri stampati e 150.000 manoscritti, inclusi codici rarissimi e documenti di inestimabile valore storico. La sua sala di consultazione, con affreschi rinascimentali, e un capolavoro artistico.

      La Biblioteca Marciana di Venezia, progettata da Jacopo Sansovino, e un gioiello architettonico del Rinascimento. Conserva manoscritti greci e latini, incunaboli e opere rare che testimoniano la ricchezza culturale della Serenissima Repubblica di Venezia.

      La Biblioteca Laurenziana di Firenze, voluta dai Medici e progettata da Michelangelo, e un esempio straordinario di architettura rinascimentale al servizio della cultura. La sua scalinata monumentale e la sala di lettura sono opere d arte che ospitano collezioni di manoscritti umanistici di inestimabile valore.

      La Biblioteca Nazionale Centrale di Roma, una delle piu grandi d Italia, conserva milioni di volumi e rappresenta un punto di riferimento fondamentale per la ricerca e lo studio. La sua collezione spazia dall antichita ai giorni nostri, coprendo ogni campo del sapere umano.

      Oltre a queste grandi istituzioni, l Italia e costellata di biblioteche storiche minori ma non meno affascinanti: biblioteche monastiche, biblioteche nobiliari, biblioteche comunali che conservano tesori spesso sconosciuti al grande pubblico.

      Visitare una biblioteca storica non e solo un esperienza culturale, ma anche spirituale. E entrare in contatto con il sapere accumulato nei secoli, con le menti che hanno plasmato la nostra civilta, con la bellezza dei libri come oggetti fisici e artistici.

      Queste biblioteche ci ricordano che i libri non sono solo contenitori di informazioni, ma ponti tra passato e futuro, testimoni silenziosi della grandezza umana e custodi della memoria collettiva.`
    }
  ];

  const post = posts.find(p => p.id === parseInt(id));

  if (!post) {
    return (
      <div className="post-detail">
        <h2>Articolo non trovato</h2>
        <Link to="/" className="btn btn-primary">
          <FaHome /> Torna alla Home
        </Link>
      </div>
    );
  }

  const handleShare = () => {
    setNotificationMessage('Funzione di condivisione disponibile a breve');
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleFavorite = () => {
    setIsFavorite(!isFavorite);
    setNotificationMessage(isFavorite ? 'Rimosso dai preferiti' : 'Aggiunto ai preferiti');
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta name="description" content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali." />
      </Helmet>

      <div className="post-detail">
      {showNotification && (
        <div className="notification">
          {notificationMessage}
        </div>
      )}

      <article>
        <div className="post-detail-header">
          <h2 className="post-detail-title">{post.title}</h2>
          <div className="post-meta">
            <span className="post-date">
              <FaShoppingCart /> {post.date}
            </span>
            <span className="post-author">{post.author}</span>
          </div>
        </div>

        <img 
          src={post.image} 
          alt={post.title} 
          className="post-detail-image"
        />

        <div className="post-detail-body">
          {post.fullContent.split('\n\n').map((paragraph, index) => (
            <p key={index}>{paragraph.trim()}</p>
          ))}
        </div>

        <div className="post-actions">
          <Link to="/" className="btn btn-primary">
            <FaHome /> Torna agli Articoli
          </Link>
          <button className="btn btn-secondary" onClick={handleShare}>
            <FaShoppingCart /> Condividi
          </button>
          <button 
            className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
            onClick={handleFavorite}
          >
            <FaHeart /> {isFavorite ? 'Salvato' : 'Salva Articolo'}
          </button>
        </div>
      </article>
    </div>
  
    </>);
}

export default PostDetail;